export function checkArraySanity(arr) {
  return (
    arr !== null && arr !== undefined && Array.isArray(arr) && arr.length > 0
  );
}
